import React from 'react';
import clsx from 'clsx';

import OverlayTooltip from '../OverlayTooltip';

export type IconType =
  | 'edit'
  | 'delete'
  | 'horn'
  | 'list'
  | 'rocket'
  | 'eye'
  | 'people'
  | 'messages'
  | 'hook'
  | 'document'
  | 'chart'
  | 'refresh'
  | 'plus'
  | 'question'
  | 'play'
  | 'broom'
  | 'loading'
  | 'link'
  | 'send'
  | 'required'
  | 'copy'
  | 'eraser'
  | 'up'
  | 'down'
  | 'left'
  | 'right'
  | 'clear'
  | 'menu_on'
  | 'menu_off';

const iconsMap: { [x in IconType]: string } = {
  horn: 'fas fa-bullhorn',
  list: 'fas fa-tasks',
  rocket: 'fas fa-rocket',
  eye: 'fas fa-eye',
  people: 'fas fa-users',
  messages: 'fas fa-comments',
  hook: 'fas fa-bolt',
  document: 'fas fa-file-alt',
  chart: 'fas fa-chart-bar',
  refresh: 'fas fa-sync',
  edit: 'fas fa-edit',
  delete: 'fas fa-trash',
  plus: 'fas fa-plus',
  question: 'fas fa-question',
  play: 'fas fa-play',
  broom: 'fas fa-broom',
  loading: 'fas fa-spinner animate-spin',
  link: 'fas fa-link',
  send: 'fas fa-paper-plane',
  required: 'fas fa-asterisk',
  copy: 'fas fa-copy',
  eraser: 'fas fa-eraser',
  up: 'fas fa-arrow-up',
  down: 'fas fa-arrow-down',
  left: 'fas fa-arrow-left',
  right: 'fas fa-arrow-right',
  clear: 'fa-solid fa-xmark',
  menu_on: 'fa-solid fa-bars',
  menu_off: 'fa-solid fa-grip-vertical',
};

const iconsStylesMap: { [x in IconStyle]: string } = {
  default: '',
  danger: 'text-[#ef4444]',
};

type IconStyle = 'default' | 'danger';

type IconProps = {
  className?: string;
  icon?: IconType;
  width?: boolean;
  tooltip?: string;

  iconStyle?: IconStyle;
  onClick?: () => void;
};

const Icon: React.FC<IconProps> = ({
  className,
  icon,
  tooltip,
  iconStyle = 'default',
  width = false,
  onClick,
}) => {
  if (!icon) return null;

  const element = (
    <i
      onClick={onClick}
      className={clsx(
        className,
        iconsMap[icon],
        iconsStylesMap[iconStyle] || iconStyle,
        width && 'w-[2rem]'
      )}
    />
  );

  return tooltip ? (
    <OverlayTooltip tooltip={tooltip}>{element}</OverlayTooltip>
  ) : (
    element
  );
};

export default React.memo(Icon) as typeof Icon;
